import React from 'react';

const InsideLaneLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    role="img"
    data-testid="insideLaneLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <rect
      id="Artboard1"
      x="0"
      y="0"
      width="200"
      height="50"
      style={{ fill: 'none' }}
    />
    <g id="Artboard11">
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <rect
          x="0"
          y="1.08"
          width="8.07"
          height="35.9"
          style={{ fill: 'rgb(20,22,22)' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <path
          d="M42.69,30.45L42,30.45L28.48,1.08L15.25,1.08L15.25,36.99L22.72,36.99L22.72,7.63L23.41,7.63L36.94,36.99L50.27,36.99L50.27,1.08L42.69,1.08L42.69,30.45Z"
          style={{ fill: 'rgb(20,22,22)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <path
          d="M78.2,17.09C76.2,16.19 73.89,15.62 71.27,15.39L68.51,15.14C66.87,15.01 65.69,14.57 64.97,13.81C64.25,13.06 63.89,12.17 63.89,11.15C63.89,10.36 64.09,9.64 64.48,8.96C64.87,8.29 65.47,7.76 66.28,7.36C67.08,6.97 68.08,6.77 69.25,6.77C70.5,6.77 71.54,7 72.37,7.46C73.21,7.92 73.84,8.52 74.27,9.26C74.69,10 74.91,10.81 74.91,11.69L82.78,11.69C82.78,9.33 82.24,7.27 81.16,5.52C80.08,3.77 78.53,2.41 76.51,1.44C74.49,0.47 72.07,-0.01 69.25,-0.01C66.43,-0.01 64.23,0.44 62.27,1.34C60.3,2.25 58.77,3.53 57.67,5.2C56.57,6.87 56.02,8.86 56.02,11.15C56.02,14.33 57.08,16.89 59.22,18.82C61.35,20.76 64.2,21.87 67.78,22.16L70.48,22.41C72.67,22.61 74.27,23.04 75.25,23.71C76.23,24.38 76.73,25.29 76.73,26.44C76.73,27.36 76.46,28.17 75.94,28.87C75.41,29.58 74.64,30.13 73.63,30.52C72.61,30.92 71.35,31.11 69.84,31.11C68.17,31.11 66.81,30.87 65.76,30.4C64.71,29.92 63.93,29.29 63.43,28.5C62.92,27.71 62.67,26.86 62.67,25.94L54.85,25.94C54.85,28.27 55.42,30.33 56.57,32.11C57.72,33.9 59.4,35.31 61.64,36.34C63.87,37.37 66.61,37.89 69.85,37.89C72.9,37.89 75.52,37.41 77.72,36.46C79.91,35.51 81.61,34.17 82.81,32.45C84,30.73 84.6,28.72 84.6,26.42C84.6,24.12 84.03,22.3 82.9,20.74C81.77,19.18 80.2,17.95 78.2,17.05L78.2,17.09Z"
          style={{ fill: 'rgb(20,22,22)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <rect
          x="89.26"
          y="1.08"
          width="8.07"
          height="35.9"
          style={{ fill: 'rgb(20,22,22)' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <path
          d="M132.44,6.1C130.8,4.46 128.77,3.17 126.34,2.21C123.91,1.26 121.08,0.78 117.83,0.78L104.5,0.78L104.5,37.18L117.83,37.18C121.08,37.18 123.91,36.67 126.34,35.66C128.77,34.64 130.8,33.29 132.44,31.6C134.08,29.91 135.3,28.01 136.11,25.9C136.91,23.79 137.31,21.65 137.31,19.48L137.31,18.4C137.31,16.07 136.91,13.85 136.11,11.73C135.3,9.62 134.08,7.74 132.44,6.1ZM128.41,23.34C127.92,24.67 127.2,25.8 126.24,26.73C125.29,27.66 124.14,28.39 122.8,28.9C121.46,29.41 119.95,29.66 118.27,29.66L112.57,29.66L112.57,8.31L118.27,8.31C119.94,8.31 121.45,8.55 122.8,9.02C124.14,9.5 125.29,10.19 126.24,11.11C127.19,12.03 127.91,13.14 128.41,14.45C128.91,15.76 129.15,17.25 129.15,18.92C129.15,20.59 128.9,21.99 128.41,23.32L128.41,23.34Z"
          style={{ fill: 'rgb(20,22,22)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <path
          d="M149.81,30.3L149.81,22.08L164.51,22.08L164.51,15.4L149.81,15.4L149.81,7.77L164.51,7.77L164.51,1.08L141.94,1.08L141.94,36.99L164.51,36.99L164.51,30.3L149.81,30.3Z"
          style={{ fill: 'rgb(20,22,22)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <rect
          x="170.17"
          y="1.08"
          width="128.91"
          height="6.69"
          style={{ fill: 'rgb(20,22,22)' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <path
          d="M178.24,36.99L170.17,36.99L170.17,72.89L192.3,72.89L192.3,65.81L178.24,65.81L178.24,36.99Z"
          style={{ fill: 'rgb(20,22,22)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <path
          d="M205.38,36.99L193.53,72.89L201.6,72.89L204.44,63.99L219.44,63.99L222.35,72.89L230.71,72.89L218.41,36.99L205.38,36.99ZM206.57,57.3L210.95,43.58L212.75,43.58L217.24,57.3L206.57,57.3Z"
          style={{ fill: 'rgb(20,22,22)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <path
          d="M261.84,66.35L261.15,66.35L247.63,36.99L234.4,36.99L234.4,72.89L241.88,72.89L241.88,43.53L242.56,43.53L256.09,72.89L269.42,72.89L269.42,36.99L261.84,36.99L261.84,66.35Z"
          style={{ fill: 'rgb(20,22,22)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <path
          d="M284.37,66.2L284.37,57.99L299.08,57.99L299.08,51.3L284.37,51.3L284.37,43.68L299.08,43.68L299.08,36.99L276.5,36.99L276.5,72.89L299.08,72.89L299.08,66.2L284.37,66.2Z"
          style={{ fill: 'rgb(20,22,22)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.40123,0,0,0.40123,40,10.3792)">
        <rect
          x="0"
          y="65.81"
          width="164.51"
          height="7.08"
          style={{ fill: 'rgb(20,22,22)' }}
        />
      </g>
    </g>
  </svg>
);

export default InsideLaneLogo;
